
import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {  SessionService } from "../../shared/services/sessionStorage.service";

@Injectable()
export class RequestsInterceptor implements HttpInterceptor {
    constructor(private localStorageService: SessionService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const accessToken: string = this.localStorageService.get("token");
        // console.log('mon token', accessToken)

        if (!request.url.startsWith('http')) {
            request = request.clone({ 
                url: `${environment.apiUrl}${request.url}` 
            });
            console.log('ma request', request);
            
        }

        if (accessToken) {
            request = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + accessToken)
            });
            console.log('ma request', request);
        }

        return next.handle(request);
    }
}